import graphql__251e6cbf242c0cc17b0d from "./__generated__/ContributionsDatavizListTheme_theme.graphql.js";
import graphql__bf2f5015938a96f4907f from "./__generated__/ContributionsDatavizListTheme_contribution.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { Outlet } from "react-router";

import { useResourcesList } from "../../../ResourcesList/resourcesList";
import { useContributionsDatavizContext } from "./ContributionsDataviz";
import useFilterableContributionsList from "../useFilterableContributionsList";
import { isResourceFilteredIn } from "../../../Utils/resourcesList";
import { useFormatMessage } from "../../../Intl/Context";
import { intlMessages as rootLayoutIntlMessages } from "./ContributionsDatavizRootLayout";
import ContributionsDatavizThemeLayout from "./ContributionsDatavizThemeLayout";
import ContributionsDatavizMainContainerHeader from "./ContributionsDatavizMainContainerHeader";
import InfinitelyScrollableContainer from "../../../Utils/InfinitelyScrollableContainer";
import ContributionsDatavizListThemeContribution from "./ContributionsDatavizListThemeContribution";
import ContributionsDatavizListContributionsGrid from "./ContributionsDatavizListContributionsGrid";

const ContributionsDatavizListTheme = props => {
  const theme = useFragment(ContributionsDatavizListTheme_theme, props.theme);
  const { participativeModule } = theme;
  const {
    search,
    items: { count: totalResultsCount }
  } = useResourcesList();

  const { contributionsPerPage: resultsPerPage } = useContributionsDatavizContext();

  const { contributions, isLoading, loadMore, emptyListMessage } =
    useFilterableContributionsList({
      contribuable: props.theme,
      fragment: ContributionsDatavizListTheme_theme,
      contributionsBatchSize: resultsPerPage
    });

  const t = useFormatMessage();
  const contributionsCountLabel = t(rootLayoutIntlMessages.contributionsCount, {
    count: totalResultsCount
  });

  const displayedContributions = useMemo(
    () =>
      contributions.filter(contribution => isResourceFilteredIn(search, contribution)),
    [contributions, search]
  );

  return (
    <ContributionsDatavizThemeLayout
      theme={theme}
      listViewActive={true}
      filtersRefetchFragment={ContributionsDatavizListTheme_theme}
      filtersRefetchFragmentParent={props.theme}
    >
      <ContributionsDatavizMainContainerHeader
        participativeModule={participativeModule}
        theme={theme}
        listViewActive
      >
        <span className="text-title-section">
          <span className="text-primary margin-right-xxs">{totalResultsCount}</span>
          {contributionsCountLabel}
        </span>
      </ContributionsDatavizMainContainerHeader>

      <InfinitelyScrollableContainer onBottomReached={loadMore}>
        <ContributionsDatavizListContributionsGrid>
          {displayedContributions.map(contribution => (
            <ContributionsDatavizListThemeContribution
              key={contribution.id}
              contribution={contribution}
              theme={theme}
            />
          ))}

          {/* Message displayed when there's no contribution, with a specific
            message, whether there is no contribution published, or if the
            filtered list has no results */}
          {emptyListMessage && <div className="box padding-md">{emptyListMessage}</div>}

          {/* Overlay displayed on top of contributions while the contributions
              list is reloaded, after the filters are updated */}
          {isLoading && <div className="container-overlay" />}
        </ContributionsDatavizListContributionsGrid>
      </InfinitelyScrollableContainer>

      {/* Allow displaying contribution modal */}
      <Outlet />
    </ContributionsDatavizThemeLayout>
  );
};

const ContributionsDatavizListTheme_theme = graphql__251e6cbf242c0cc17b0d;

graphql__bf2f5015938a96f4907f;

export default ContributionsDatavizListTheme;
